var render, staticRenderFns
import script from "./CMenu.vue?vue&type=script&lang=ts"
export * from "./CMenu.vue?vue&type=script&lang=ts"
import style0 from "./CMenu.vue?vue&type=style&index=0&id=54f2df5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports